import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";
import { WFormArray } from "../..";
import { ControlContext } from "../WControlProvider/ControlContext";
export const WFormArrayElement = props => {
  const {
    getKey
  } = props;

  const newProps = _extends({}, props, {
    control: props.control
  });

  return /*#__PURE__*/React.createElement(WFormArray, newProps, ({
    control,
    status,
    errors,
    validationErrors,
    validationStatus
  }) => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, status === "SUCCESS" && /*#__PURE__*/React.createElement(React.Fragment, null, control.controls.map((control, i) => {
      const key = getKey ? getKey(control, i) : `${i.toString()}-AUTOGENERATED`;
      const parentControlContext = {
        control,
        status: "SUCCESS",
        errors: null,
        validationErrors,
        validationStatus,
        index: i
      };
      return /*#__PURE__*/React.createElement(ControlContext.Provider, {
        value: parentControlContext,
        key: key || `${i.toString()}-AUTOGENERATED`
      }, typeof props.children === "function" ? props.children(parentControlContext) : props.children);
    })), status === "PROCESSING" && /*#__PURE__*/React.createElement(React.Fragment, null), status === "FAILURE" && /*#__PURE__*/React.createElement(React.Fragment, null, JSON.stringify(errors)));
  });
};